export default __webpack_public_path__ + "static/media/expand.841516c9.jpeg";